import React from 'react';

import { Page } from '@nearst/ui';
import styles from './RestrictedPage.module.scss';

export default function RestrictedPage({ className = '', children }) {
	return <Page.Section className={`${styles.restrictedPage} ${className}`}>{children}</Page.Section>;
}
